import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { authService } from '../services/auth.service';
import { userManagementService } from '../services/user-management.service';

const ProtectedRoute: React.FC = () => {
  const location = useLocation();  // To capture the current route
  
  // Check if the user is logged in
  if (!authService.isLoggedIn()) {
    // If not logged in, redirect to the login page
    return <Navigate to="/niet-toegestaan" state={{ from: location }} replace />;
  }

  const organisatie = userManagementService.getStoredOrganisatie();
  if (!organisatie?.id && location.pathname !== "/mijn/organisaties") {
    return <Navigate to="/mijn/organisaties" state={{ from: location }} replace />;
  }

  return <Outlet />;  // Render child routes if authenticated
};

export default ProtectedRoute;
